import React from 'react';
import { Page } from '../types';

interface HowItWorksProps {
  setPage: (page: Page) => void;
}

const HowItWorks: React.FC<HowItWorksProps> = ({ setPage }) => {
  const steps = [
    { title: "Consultation", desc: "Speak with an expert to determine the best structure for your business.", icon: "forum" },
    { title: "Information Submission", desc: "Securely provide your details during our discovery session.", icon: "event_note" },
    { title: "Processing & Filing", desc: "Our team handles the bureaucracy. We handle all filing details for you.", icon: "history_edu" },
    { title: "Delivery", desc: "Receive your verified certificates and compliance documents via email and courier.", icon: "local_shipping" },
  ];

  return (
    <div className="pt-32 pb-24 animate-fade-in">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center max-w-3xl mx-auto mb-20">
          <h1 className="text-5xl font-display font-bold text-slate-900 dark:text-white mb-6">Simplicity by Design.</h1>
          <p className="text-xl text-slate-600 dark:text-slate-400">The process of registering and managing a business shouldn't be a nightmare. We've distilled it into 4 easy steps.</p>
        </div>

        <div className="relative">
          {/* Connector Line */}
          <div className="hidden lg:block absolute top-1/2 left-0 w-full h-0.5 bg-slate-100 dark:bg-slate-800 -translate-y-1/2"></div>
          
          <div className="grid lg:grid-cols-4 gap-12">
            {steps.map((step, i) => (
              <div key={i} className="relative z-10 text-center flex flex-col items-center">
                <div className="w-24 h-24 bg-white dark:bg-slate-800 border-4 border-slate-50 dark:border-slate-900 shadow-2xl rounded-[32px] flex items-center justify-center mb-8 hover:scale-110 hover:border-primary transition-all duration-500">
                  <span className="material-symbols-rounded text-primary text-4xl">{step.icon}</span>
                </div>
                <h3 className="text-2xl font-bold text-slate-900 dark:text-white mb-4">{step.title}</h3>
                <p className="text-slate-600 dark:text-slate-400 leading-relaxed">{step.desc}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-32 text-center bg-primary rounded-[40px] p-12 lg:p-24 text-white">
          <h2 className="text-4xl font-bold mb-8">Ready to get started?</h2>
          <p className="text-xl text-blue-100 mb-12 max-w-2xl mx-auto">Join thousands of entrepreneurs who trust FinTrack with their business foundation.</p>
          <div className="flex flex-col sm:flex-row gap-6 justify-center">
            <button onClick={() => setPage('booking')} className="px-10 py-4 bg-white text-primary font-bold rounded-2xl hover:bg-accent transition-all flex items-center gap-2">
              <span className="material-symbols-rounded">calendar_month</span>
              Book Strategy Session
            </button>
            <button onClick={() => setPage('contact')} className="px-10 py-4 bg-transparent border-2 border-white/20 text-white font-bold rounded-2xl hover:bg-white/10 transition-all">
              Contact Us
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HowItWorks;